export { default as CuratedCatalogPage } from './components/CuratedCatalogPage';
export const CuratedCatalogPageDynamic = () => import('./components/CuratedCatalogPage');

export { default as CatalogItemDetailPage } from './components/CatalogItemDetailPage';
export const CatalogItemDetailPageDynamic = () => import('./components/CatalogItemDetailPage');

export { default as CatalogEditContentPage } from './components/CatalogEditContentPage';
export const CatalogEditContentPageDynamic = () => import('./components/CatalogEditContentPage');
